<ng-template #first>
  <i class="pi pi-angle-double-right"></i>
</ng-template>
<ng-template #previous>
  <i class="pi-angle-right pi"></i>
</ng-template>
<ng-template #next>
  <i class="pi-angle-left pi"></i>
</ng-template>
<ng-template #last>
  <i class="pi pi-angle-double-left"></i>
</ng-template>
<ng-template #ellipsis>...</ng-template>
<ng-template #defaultNumber let-page let-currentPage="currentPage">
  {{ page }}
</ng-template>
<ng-template #currentPageReport>
  {{'VIEW'|translate}} {{ (page-1)*pageSize +1 }} - {{page*pageSize }} {{'FROM'}} {{collectionSize}}
</ng-template>
<span>
  <ng-template *ngIf="showCurrentPageReport" [ngTemplateOutlet]="currentPageReport"></ng-template>
</span>
<a *ngIf="boundaryLinks" [class.disabled]="previousDisabled()" aria-label="First"
  i18n-aria-label="@@ng.pagination.first-aria" class="btn btn-paging" href
  (click)="selectPage(1); $event.preventDefault()" [attr.tabindex]="previousDisabled() ? '-1' : null"
  [attr.aria-disabled]="previousDisabled() ? 'true' : null">
  <ng-template [ngTemplateOutlet]="tplFirst.templateRef || first" [ngTemplateOutletContext]="{
      disabled: previousDisabled(),
      currentPage: page
    }"></ng-template>
</a>
<a *ngIf="directionLinks" [class.disabled]="previousDisabled()" aria-label="Previous"
  i18n-aria-label="@@ng.pagination.previous-aria" class="btn btn-paging" href
  (click)="selectPage(page - 1); $event.preventDefault()" [attr.tabindex]="previousDisabled() ? '-1' : null"
  [attr.aria-disabled]="previousDisabled() ? 'true' : null">
  <ng-template [ngTemplateOutlet]="tplPrevious?.templateRef || previous"
    [ngTemplateOutletContext]="{ disabled: previousDisabled(), }"></ng-template>
</a>
<ng-container *ngFor="let pageNumber of pages">
  <a *ngIf="isEllipsis(pageNumber)" class="btn btn-paging" tabindex="-1" aria-disabled="true"
    [class.active]="pageNumber === page" [class.disabled]="isEllipsis(pageNumber) || disabled"
    [attr.aria-current]="pageNumber === page ? 'page' : null">
    <ng-template [ngTemplateOutlet]="tplEllipsis.templateRef || ellipsis"
      [ngTemplateOutletContext]="{ disabled: true, currentPage: page }"></ng-template>
  </a>
  <a *ngIf="!isEllipsis(pageNumber)" class="btn  btn-paging" (click)="selectPage(pageNumber); $event.preventDefault()"
    [attr.tabindex]="disabled ? '-1' : null" [attr.aria-disabled]="disabled ? 'true' : null"
    [class.active]="pageNumber === page" [class.disabled]="isEllipsis(pageNumber) || disabled"
    [attr.aria-current]="pageNumber === page ? 'page' : null">
    <ng-template [ngTemplateOutlet]="tplNumber.templateRef || defaultNumber" [ngTemplateOutletContext]="{
        disabled: disabled,
        $implicit: pageNumber,
        currentPage: page
      }"></ng-template>
  </a>
</ng-container>
<a aria-label="Next" i18n-aria-label="@@ng.pagination.next-aria" class="btn btn-paging"
  (click)="selectPage(page + 1); $event.preventDefault()" [attr.tabindex]="nextDisabled() ? '-1' : null"
  [attr.aria-disabled]="nextDisabled() ? 'true' : null" *ngIf="directionLinks" [class.disabled]="nextDisabled()">
  <ng-template [ngTemplateOutlet]="tplNext.templateRef || next" [ngTemplateOutletContext]="{
      disabled: nextDisabled(),
      currentPage: page
    }"></ng-template>
</a>
<a aria-label="Last" i18n-aria-label="@@ng.pagination.last-aria" class="btn btn-paging"
  (click)="selectPage(pageCount); $event.preventDefault()" [attr.tabindex]="nextDisabled() ? '-1' : null"
  [attr.aria-disabled]="nextDisabled() ? 'true' : null" *ngIf="boundaryLinks" [class.disabled]="nextDisabled()">
  <ng-template [ngTemplateOutlet]="tplLast.templateRef || last" [ngTemplateOutletContext]="{
      disabled: nextDisabled(),
      currentPage: page
    }"></ng-template>
</a>
